import { App } from 'antd';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes } from '@/routes';
import { useFaceEnrollmentModule } from '@/hooks';
import { useUniversityContext, useUserContext } from '@/context';

export function FaceEnrollmentCheck() {

  const { pathname } = useLocation();
  const { message } = App.useApp();
  const [t] = useTranslation(['common']);
  const { loading: profileLoading } = useUserContext();
  const { loading: universityLoading } = useUniversityContext();
  const { forceEnrollment } = useFaceEnrollmentModule();

  useEffect(() => {
    if (forceEnrollment) {
      message.warning({
        duration: 4,
        key: 'force-change-profile-image',
        content: t('common:errors.face-auth-required'),
      });
    }
  }, [forceEnrollment, message, t]);

  if (pathname != Routes.Face && !universityLoading && !profileLoading && forceEnrollment) {
    return <Navigate to={Routes.Face} />;
  }

  return <></>;

}

export default FaceEnrollmentCheck;
